import Vue from 'vue';
import Router from 'vue-router';
import { securityService } from '@/Application/Services/auth/SecurityService';
import { store } from '@/Store';
import { Roles } from '@/Domain/enum';
import { routes } from './index';
import { normalizeProcessType } from './guards';
import AdminEnrolledOnBlockedProcessRouteGuardService from '../Services/AdminEnrolledOnBlockedProcessRouteGuardService';

Vue.use(Router);
export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  normalizeProcessType(to);
  next();
});

router.beforeEach(async (to, from, next) => {
  const authData = store.state.userStore.authData ? store.state.userStore.authData : await securityService.getTokenInfo();
  store.commit('userStore/setAuthData', authData);

  if (!authData || authData.role === Roles.NOROLE || authData.role === Roles.DISABLED) {
    if (to.path !== '/accessdenied') {
      next('/accessdenied');
    } else {
      next();
    }
    return;
  }

  const { adminBlockedProcessIds } = await AdminEnrolledOnBlockedProcessRouteGuardService.getAdminBlockedAndEnrolledProcessIds(store);
  const isAdminDeniedOnRoute = AdminEnrolledOnBlockedProcessRouteGuardService.isAdminDeniedIOnRoute(to.name ? to.name : '', [ ...adminBlockedProcessIds ], to.params);

  if (isAdminDeniedOnRoute) {
    next('/accessdenied');
    return;
  }

  if (!to.meta.areAllRolesAllowed) {
    if (to.path === '/') {
      if (authData.role === Roles.ADMIN) {
        next('/dashboard');
      } else {
        next('/ratings');
      }
      return;
    }

    if (to.meta.role.includes(authData.role)) {
      next();
    } else {
      next('/accessdenied');
    }
  } else {
    next();
  }
});
